<div class="document-picker link-list-items">
  <mat-form-field appearance="legacy">
      <mat-label class="doc-picker-title">Documents Tab</mat-label>
      <mat-select (selectionChange)="handleSelection($event.value)" multiple>
        <mat-option *ngFor="let document of documents"
          [disabled]="document.scanStatus !== 'CLEAN'"
          [value]="document"
          class="document-list">
          {{ document.title }}
        </mat-option>
      </mat-select>
    </mat-form-field>
</div>
